import {PostChatRoomV2} from 'domain/usecases';
import {RemotePostChatRoomV2} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makePostChatRoomV2 = (): PostChatRoomV2 =>
	new RemotePostChatRoomV2(
		makeBFFApiUrl(ExternalLinkPoint.chatRoomv2),
		makeAuthorizeHttpClientDecorator(),
	);
